<a class="ga-event" routerLink="/racing-hq" data-dest="Racing HQ" data-ga_category="Home" data-ga_action="Click" data-ga_label="Racing HQ Tile">
  <div class="cta-content">
    <div class="title">Racing HQ</div>
    <div class="description">Get current season info, drag racing 101 and news</div>
  </div>
</a>
